import styled from "styled-components";
import { StyledCtaButton } from "../../ctaButton/ctaButton.style";

export const StyledButton = styled(StyledCtaButton)`
  padding: 12px 24px;
  ${({ theme }) => theme.fontStyles.InterfaceCopyXLargeBold}
  border-radius: 24px !important;
`;

export const StyledWrapper = styled.div`
  .page-back-link {
    margin-top: 16px;
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.InterfaceCopyBold}
    display: flex;

    a {
      display: flex;
      gap: 2px;

      &:active,
      &:hover {
        color: ${({ theme }) => theme.colors.primaryText};
        text-decoration: underline;
      }

      &:focus-visible {
        outline: none;
      }
    }

    svg {
      width: 12px !important;
      height: 12px !important;
    }
  }

  .page-content {
    margin-top: 16px;
    padding: 0 40px;
    background-color: ${({ theme }) => theme.colors.primaryLightFill};
  }

  .page-controls {
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}
    display: flex;
    gap: 16px;
    align-items: center;

    .label {
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
      line-height: 20px;
    }

    .value {
      margin-left: 4px;
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopy}
      line-height: 20px;
    }
  }

  .page-heading {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    }
  }

  .page-section {
    padding: 48px 0;
    width: 700px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.primaryRulerTint50};

    &:last-child {
      border-bottom: 0;
    }
  }

  .section-content {
    margin-bottom: 12px;
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}
    line-height: 22px;
    display: flex;
    gap: 18px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-heading {
    margin-bottom: 32px;
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
  }

  .section-label {
    width: 265px;
    color: ${({ theme }) => theme.colors.neutralsText};
  }

  .section-value {
    color: ${({ theme }) => theme.colors.neutralsTextLight};

    strong {
      color: ${({ theme }) => theme.colors.primaryText};
    }
  }
`;
